/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import { PREFIX } from '../constants';
import { FETCH_PERMIT } from '../constants/actions';
import { RootState } from '../../dev/store';

const fetchPermit = makeAsyncReducer(FETCH_PERMIT);

export default mergeReducers(asyncDefaults([]), PREFIX, fetchPermit);

export const selectors = {
    getPermit: (state: RootState) => state.treePermit.permit.data,
};
